<template lang="pug">
  .c-highlights
    .c-highlights--loaded(v-if='!loaded')
      .c-highlight__item.c-highlight__item--static-ibe(v-for='(offer, index) in offers' :key="index")
        StaticIBEOffer(
          :offer="offer",
          :parentIndex="parentIndex",
          :myIndex="index"
        )
    .c-hightlights--loading(v-else)
      span.c-hightlights--loading__point
      span.c-hightlights--loading__point
      span.c-hightlights--loading__point
</template>

<script>
import axios from 'axios'
import StaticIBEOffer from '@/components/StaticIBEOffer'

export default {
  props: ['parentElement', 'parentIndex'],
  name: 'StaticIBE',
  components: {
    StaticIBEOffer
  },
  data() {
    return {
      notEmpty: true,
      loaded: true,
      offers: [],
      dynamicDateRange: [14, 56],
      tracked: false,
      trackHostNames: this.$store.getters.getTrackingHostNames,
      trackingAllowed: true
    }
  },
  mounted() {
    this.loaded = false
  },
  computed: {
    mvTranslate() {
      if (this.$store.state.hash !== undefined) {
        return this.$store.getters.getMvTranslate
      }
      return false
    }
  },
  created() {
    let offers = []
    let bananas = document.querySelectorAll(
      '#' + this.parentElement + ' > .bananas-static-ibe'
    )
    for (let i = 0; i < bananas.length; i++) {
      if (bananas[i].getAttribute('data-bn') !== null) {
        const offerData = this.getBananasStaticTeaserData(
          bananas[i].getAttribute('data-bn')
        )
        offerData.partner = 'traveltainment'
        offers.push(offerData)
      }
    }
    offers.forEach(offer => {
      offer.then(value => {
        if (value.data.image !== undefined) {
          value.data.hotel.category = this.reformatHotelCategory(
            String(value.data.hotel.category)
          )
          this.offers.push(value.data)
        }
      })
    })
  },
  methods: {
    getBananasStaticTeaserData(staticUrl) {
      staticUrl = staticUrl.split('#')
      const sourceParams = new URLSearchParams(staticUrl[1])
      let resultParams = []
      const departureAirports = sourceParams.getAll('departure_airports[]')
      const departureDate = new Date(sourceParams.get('departure_date_min'))
      let depDate = sourceParams.get('departure_date_min')
      let arrDate = sourceParams.get('arrival_date_max')
      if (Date.now() > Date.parse(departureDate)) {
        depDate = this.setNewDate(
          new Date(sourceParams.get('departure_date_min')),
          this.dynamicDateRange[0]
        )
        arrDate = this.setNewDate(
          new Date(sourceParams.get('departure_date_min')),
          this.dynamicDateRange[1]
        )
      }
      if (departureAirports.length > 1) {
        departureAirports.forEach(element => {
          resultParams.push('departure_airports[]=' + element)
        })
      } else {
        resultParams.push(
          'departure_airports[]=DTM&departure_airports[]=DUS&departure_airports[]=FRA&departure_airports[]=HHN&departure_airports[]=KSF&departure_airports[]=CGN&departure_airports[]=FMO&departure_airports[]=PAD&departure_airports[]=SCN&departure_airports[]=NRN&departure_airports[]=SXF&departure_airports[]=TXL&departure_airports[]=DRS&departure_airports[]=ERF&departure_airports[]=LEJ&departure_airports[]=CSO&departure_airports[]=RLG&departure_airports[]=BRE&departure_airports[]=HAM&departure_airports[]=HAJ&departure_airports[]=LBC&departure_airports[]=FDH&departure_airports[]=FKB&departure_airports[]=FMM&departure_airports[]=MUC&departure_airports[]=NUE&departure_airports[]=STR'
        )
      }
      const children = sourceParams.getAll('child_age[]')
      if (children.length > 1) {
        children.forEach(element => {
          resultParams.push('child_age[]=' + element)
        })
      }
      if (sourceParams.get('board_min') !== null) {
        resultParams.push('board_min=' + sourceParams.get('board_min'))
      }
      resultParams.push('adults=' + sourceParams.get('adults'))
      resultParams.push('departure_date_min=' + depDate)
      resultParams.push('arrival_date_max=' + arrDate)
      resultParams.push('duration_min=' + sourceParams.get('duration_min'))
      resultParams.push('duration_max=' + sourceParams.get('duration_max'))
      resultParams.push('ref_source=' + sourceParams.get('ref_source'))
      let data = {
        hotelid: sourceParams.get('hotel_id'),
        params: resultParams.join('&')
      }
      return axios.post(
        'https://motrack.holidaypirates.group/pirateplank/ibe',
        data,
        {
          headers: { 'Content-Type': 'application/json' }
        }
      )
    },
    reformatHotelCategory(hotelCategory) {
      let newCategory = hotelCategory.split('.')
      let points = []
      for (let i = 0; i < parseInt(newCategory[0]); i++) {
        points.push('1')
      }
      if (newCategory.length > 1) {
        newCategory = [points, true]
      } else {
        newCategory = [points, false]
      }
      return newCategory
    },
    setNewDate(date, daysToAdd) {
      date = new Date(date.setDate(date.getDate() + daysToAdd)).toISOString()
      date = date.split('T')[0]
      return date
    }
  },
  filters: {
    formatDate(date) {
      return new Date(date).toLocaleDateString('de-de')
    }
  }
}
</script>
